import React, { useState } from 'react';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <div className="navbar-logo">
          <img src="/Taxi-Cabs-247.webp" alt="Taxicabs-247 Logo" />
          <div className="logo-text">
            <span className="logo-main">TAXI CABS</span>
            <span className="logo-sub">247</span>
          </div>
        </div>
        <div className={`navbar-links ${menuOpen ? 'open' : ''}`}>
          <a href="#home" onClick={() => setMenuOpen(false)}>Home</a>
          <a href="#about" onClick={() => setMenuOpen(false)}>About Us</a>
          <a href="#services" onClick={() => setMenuOpen(false)}>Our Services</a>
          <a href="#airport-transfers" onClick={() => setMenuOpen(false)}>Airport Transfers</a>
          <a href="#contact" onClick={() => setMenuOpen(false)}>Contact Us</a>
        </div>
        <a href="#contact" className="navbar-cta">Contact Us</a>
        <button className="navbar-toggle" onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle menu">
          {menuOpen ? '✕' : '☰'}
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
